export default {
  padding: {
    top: '3.75rem',
    right: '0.9375rem',
    bottom: '3.75rem',
    left: '0.9375rem',
  },
  maxWidth: '62.5rem',
};
